import { useEffect, useState } from 'react'

import { CustomerProfileTabProps } from '../../../models/CustomerProfileTab'
import {
    Configuration,
    PermissionConfig,
} from '../../../models/PermissionConfig'
import { sortByString } from '../../../utils/Utils'
import { getConfigList, saveConfigList } from '../../AppPermissionsAPI'
import CustomConfigClientProfile from '../components/CustomConfigClientProfile'
import {
    formatConfigItems,
    formatNewConfigList,
} from '../utils/ConfigListFormaters'

export default function SalesChannelTab({
    parameters,
    availableItems,
}: CustomerProfileTabProps) {
    const [configList, setConfigList] = useState<Configuration[]>([])
    const [configItems, setConfigItems] = useState<PermissionConfig[]>([])
    const [initialConfigItems, setInitialConfigItems] = useState<
        PermissionConfig[]
    >([])
    const [selectedParameterValue, setSelectedParameterValue] =
        useState<string>('all')
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [configLoadingFailed, setConfigLoadingFailed] =
        useState<boolean>(false)
    const [blockedByAllItems, setBlockedByAllItems] = useState<Set<string>>(
        new Set()
    )

    useEffect(() => {
        if (configList.length > 0 && selectedParameterValue) {
            const newConfigItems = formatConfigItems(
                selectedParameterValue,
                configList
            )
            setInitialConfigItems(newConfigItems)
            setConfigItems(newConfigItems)
        }
    }, [selectedParameterValue, configList])

    useEffect(() => {
        loadConfigList()
    }, [])

    useEffect(() => {
        isBlockedByAllItem()
    }, [selectedParameterValue, configList])

    const isBlockedByAllItem = () => {
        if (selectedParameterValue === 'all') {
            setBlockedByAllItems(new Set())
            return
        }
        const allConfig = configList.find((item) => item.option === 'all')
        const selectedItemsSet = allConfig?.list.map((item) => item.item)
        setBlockedByAllItems(new Set(selectedItemsSet))
    }

    const loadConfigList = async () => {
        try {
            setIsLoading(true)
            const {
                data: { config },
            } = await getConfigList('products/salesChannelsConfig')
            setConfigList(config)
        } catch (err) {
            console.error(err)
            setConfigLoadingFailed(true)
            setConfigList([])
        } finally {
            setIsLoading(false)
        }
    }

    const handleSave = async () => {
        if (!selectedParameterValue) return

        const body = formatNewConfigList(
            selectedParameterValue,
            configList,
            configItems
        )

        try {
            await saveConfigList('products/salesChannelsConfig', body)
        } catch (error) {
            console.error(
                `Erro ao salvar configuração por setor industrial. ${error}`
            )
            throw error
        } finally {
            loadConfigList()
        }
    }

    const handleCancel = (configs: PermissionConfig[]) => {
        setConfigItems(configs)
    }

    return (
        <CustomConfigClientProfile
            availableItems={sortByString(availableItems, 'name')}
            configItems={sortByString(configItems, 'item')}
            initialConfigItems={sortByString(initialConfigItems, 'item')}
            parameters={sortByString(parameters, 'title')}
            parameterType="salesChannel"
            isLoading={isLoading}
            configLoadingFailed={configLoadingFailed}
            onCancel={handleCancel}
            onChangeConfigItems={setConfigItems}
            onChangeSelectedParameterValue={setSelectedParameterValue}
            onSave={handleSave}
            blockedByAllItems={blockedByAllItems}
            selectedParameterValue={selectedParameterValue}
        />
    )
}
